export enum FeatureFlag {
  SPOTTARIF = 'rechnungen-show_spot_tariff',
  SUBUSER = 'subusers-enable_registration',
  INVOICE_FILTER_EXTENDED = 'rechnungen-show_extended_filter',
  UMMELDUNG = 'zaehlpunkte-enable_ummeldung',
  CONSUMPTION = 'zaehlpunkt_details-show_consumption_card',
}

export interface FeatureFlagResponse {
  enabled: boolean;
}
